import request from '../../plugins/request'

export function getAuthorUserToEditorList (data) {
  return request({
    url: '/api/AuthorUser/GetAuthorUserToEditorList',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

export function updateAuthorUserbyEditorId (data) {
  return request({
    url: '/api/AuthorUser/UpdateAuthorUserbyEditorId',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

export function getAuthorContractServiceInfo (data) {
  return request({
    url: '/api/AuthorContract/GetAuthorContractByAuthorId',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

export function getAuthorGuarantorServiceInfo (data) {
  return request({
    url: '/api/AuthorGuarantor/GetAuthorGuarantorByAuthorId',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

export function getEditorIdbyUserId (data) {
  return request({
    url: '/api/AuthorUser/GetUserEditorIdbyUserId',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

export function getAuthorUserbyId (data) {
  return request({
    url: '/api/AuthorUser/GetAuthorUserbyId',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

export function updateAuthorUserInfoNotNull (data) {
  return request({
    url: '/api/AuthorUser/UpdateAuthorUserInfoNotNull',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

export function updateAuthorContractServiceInfo (data) {
  return request({
    url: '/api/AuthorContract/UpdateAuthorContractServiceInfo',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}

export function updateAuthorGuarantorServiceInfo (data) {
  return request({
    url: '/api/AuthorGuarantor/UpdateAuthorGuarantorServiceInfo',
    method: 'post',
    baseURL: process.env.VUE_APP_BASE_API,
    data
  })
}
